import { postCreateMessanger } from '../api/postCreateMessanger';

const setPostCreateMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateMessanger(params);
            window.location.replace('/settings/messanger')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateMessanger
}